import React from "react";
import ClientIntakeFrom from "../ClientIntake/clientIntakeFrom";


const ManageSubmission = () => {

  return (
    <ClientIntakeFrom />
  );
};

export default ManageSubmission;